<template>
  <div>
    <div class="row">
      <div class="col-md-7">
        <div v-if="false">
          <div v-if="!useAutoList">
            Выберите препарат
            <ajaxDrugSearch ref="ajaxSearch" :selectedDrug="selectDrug"/>
          </div>

          <div>
            <input id="check_2" type="checkbox" v-model="useAutoList">
            <label for="check_2">На основе автосписка</label>
          </div>
        </div>

        <div class="select_radio">
<!--          <div class="form-group">-->
<!--            <input type="radio" id="r_1" name="r_1" value="1" v-model="filterList">-->
<!--            <label for="r_1">На основе наличия на складе</label>-->
<!--          </div>-->
          <div class="form-group">
            <input type="radio" id="r_2" name="r_1" value="2" v-model="filterList">
            <label for="r_2">Для построения автосписка</label>
          </div>
          <div class="form-group">
            <input type="radio" id="r_3" name="r_3" value="3" v-model="filterList">
            <label for="r_3">Вся бронь</label>
          </div>

          <div class="form-group">
            <input type="radio" id="r_4" name="r_4" value="5" v-model="filterList">
            <label for="r_4">На основе накладных</label>
          </div>

          <div class="form-group">
            <input type="radio" id="r_5" name="r_5" value="6" v-model="filterList">
            <label for="r_5">Проблемные заявки</label>
          </div>
        </div>

        <div class="subRadio" v-if="filterList == 6">
          <div class="form-group">
            <input type="radio" id="r_1_1" name="r_1_1" value="1" v-model="subFilter.conflict">
            <label class="pointer" for="r_1_1">не назначенные вовремя старшим курьером</label>

            <div class="form-check">
              <input class="form-check-input" :disabled="!(subFilter.conflict == 1)" v-model="subFilter.notAppointedByChiefOrders" type="checkbox" id="gridCheck5">
              <label class="form-check-label" for="gridCheck5">
                в том числе заявки на завтра
              </label>
            </div>

          </div>
          <hr>
          <div class="form-group">
            <input type="radio" id="r_1_2" name="r_1_2" value="2" v-model="subFilter.conflict">
            <label class="pointer" for="r_1_2">не согласованные и с отсутствующим свободным товаром на эти заявки</label>
          </div>
        </div>


        <div v-if="cities">
          Выберите город
          <select class="form-control" @change="cityUpdated" v-model="selectedCity">
            <!--                        <option :disabled="useAutoList" value="all">Любой город</option>-->
            <!--                        <option :disabled="useAutoList" value="0">Почта</option>-->
            <option v-for="(city, index) in citiesForSelect" v-if="$currentRole === 'admin' || ($currentRole !== 'admin' && !citiesForAdminOnly.includes(city.id))" :value="city.id">{{city.title}}</option>
            <option value="11+12">Курск + Белгород</option>
            <option value="1+0">Москва + Почта</option>
            <option value="0">Почта</option>
            <option v-if="filterList == 6" value="-1">Все города</option>
          </select>
        </div>
      </div>
      <div class="col-md-5">

        <div v-if="filterList == 5">
          <div class="form-group">
            <label for="">Введите ID накладных через запятую</label>
            <input class="form-control" type="text" placeholder="5555,7777" v-model="selectedInvoices">
          </div>
        </div>

        <div class="selected_drugs">
          <div v-for="(drug, id, index) in sortedRecords(selectedDrugs)" class="btn-group" role="group">
            <button type="button" class="btn btn-primary btn-sm title">{{drug.title}} | {{drug.id}}</button>
            <button type="button" @click="removeSelectedDrug(drug.id)" class="btn btn-warning btn-sm">-</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import ajaxDrugSearch from '@/components/drugs/ajaxSearch'

  export default {
    components: {
      ajaxDrugSearch
    },
    props: [
      'cities','cityUpdated', 'searchOrders', 'filterUpdated'
    ],
    data() {
      return {
        citiesForAdminOnly: [11,12],
        filterList: 2,
        selectedInvoices: null,
        useAutoList: false,
        selectedDrug: null,
        selectedDrugs: {},
        selectedCity: 'all',
        citiesForAutoList: [],
        citiesForSelect: [],
        subFilter: {
          conflict: 1,
          notAppointedByChiefOrders: false,
        }
      }
    },
    mounted() {
      this.updateCities(false);
    },
    watch: {
      useAutoList: function () {
        this.updateCities();
        if (this.useAutoList && (this.selectedCity == 0 || this.selectedCity == 'all'))
          this.selectedCity = this.cities[0].id;
      },
      filterList: function() {
        this.updateCities(false);
        this.filterUpdated();
      }
    },
    methods: {
      updateCities(sendUpdate = true) {
        this.citiesForSelect = [];

        if (typeof this.cities == 'object') {
          Object.keys(this.cities).forEach((k) => {
            // if (this.cities[k].id != 1)
            if (this.filterList == 5) {
              if (this.cities[k].id == 1) {
                this.citiesForSelect.push(this.cities[k]);
              }
            }else if (this.filterList == 6) {
              this.citiesForSelect.push(this.cities[k]);
            }else {
              this.citiesForSelect.push(this.cities[k]);
            }
          })
        } else {
          this.cities.forEach((c) => {
            if (c.id != 1)
              this.citiesForSelect.push(c);
          })
        }

        this.selectedCity = this.citiesForSelect[0].id;
        if (sendUpdate)
          this.searchOrders();
        return;


        if (this.useAutoList) {
          this.cities.forEach((c) => {
            if (c.id != 1)
              this.citiesForSelect.push(c);
          })
        } else {
          console.log(typeof this.cities);
          if (typeof this.cities == 'object') {
            Object.keys(this.cities).forEach((k) => {
              this.citiesForSelect.push(this.cities[k]);
            })
          } else {
            this.cities.forEach((c) => {
              this.citiesForSelect.push(c);
            })
          }
          // this.citiesForSelect = [...this.cities];
        }
        this.selectedCity = this.citiesForSelect[0].id;
      },
      sortedRecords(records) {
        return _.orderBy(records, 'title');
      },
      removeSelectedDrug(drugId) {
        delete this.selectedDrugs[drugId];
        this.selectedDrugs = {...this.selectedDrugs};
      },
      selectDrug(drug) {
        if (drug && !this.selectedDrugs[drug.id]) {
          this.$set(this.selectedDrugs, drug.id, drug);
          setTimeout(() => {
            console.log(document.querySelector('.v-select input').focus());
          }, 350);
        }
      }
    }
  }

</script>

<style scoped>
  .select_radio .form-group {
    margin-bottom: 0;
  }
  .subRadio{
    margin-left: 15px;
    font-size: 15px;
  }
  .subRadio .form-group{
    margin: 0;
  }
  .selected_drugs .btn-group {
    width: 100%;
    margin-bottom: 2px;
  }

  .selected_drugs .btn-group .title {
    text-align: left;
    width: calc(100% - 100px);
  }
</style>
